import { ReactNode } from 'react';
import { motion, useReducedMotion } from 'framer-motion';

/**
 * Reveal — shared scroll-reveal wrapper for homepage bands.
 * Reduced-motion users (and no-JS) get static, fully visible content.
 */

interface RevealProps {
    children: ReactNode;
    delay?: number;
    className?: string;
}

const Reveal = ({ children, delay = 0, className }: RevealProps) => {
    const reduced = useReducedMotion();

    if (reduced) {
        return <div className={className}>{children}</div>;
    }

    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.65, delay, ease: [0.22, 1, 0.36, 1] }}
        >
            {children}
        </motion.div>
    );
};

export default Reveal;
